import React from 'react';
import { Box, createStyles, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { PendingReleaseCards } from './PendingReleaseCards';
import { useSurgeons } from '@utilities/hooks/useSurgeons/useSurgeons';
import { useGetTimeZoneByHospital } from '@utilities/hooks/useGetTimeZoneByHospital/useGetTimeZoneByHospital';
import { useGetFilteredReleases } from '@components/BlockRelease/utils/hooks/useGetFilteredReleases/useGetFilteredReleases';

const useStyles = makeStyles((theme) =>
	createStyles({
		releasesHeader: {
			color: theme.palette.secondary.main,
			fontSize: '1.125rem',
		},
		releasesSection: {
			display: 'flex',
			flexDirection: 'column',
			gap: theme.spacing(2),
		},
	}),
);

export const PendingReleases = () => {
	const classes = useStyles();

	const { surgeonByNpi } = useSurgeons();
	const timeZoneByHospital = useGetTimeZoneByHospital();

	const { pendingReleases } = useGetFilteredReleases();

	if (!pendingReleases?.length) {
		return null;
	}

	return (
		<>
			<Typography variant="h2" className={classes.releasesHeader}>
				Pending Releases
			</Typography>
			<Box className={classes.releasesSection}>
				<PendingReleaseCards
					releases={pendingReleases}
					surgeonByNpi={surgeonByNpi}
					timeZoneByHospital={timeZoneByHospital}
				/>
			</Box>
		</>
	);
};
